import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import "./Sidebar.css";
import LottieIcon from "../LottieIcon/LottieIcon";

export const CustomSidebar = ({ menuItems = [], activeItem = null, className = "", width = "240px", title }) => {
  const location = useLocation();
  const [localActive, setLocalActive] = useState(null);
  const [hoveredItem, setHoveredItem] = useState(null);
  const currentActive =
    activeItem || localActive || menuItems.find((item) => item.link && location.pathname && item.link.startsWith(location.pathname))?.id;

  const handleItemClick = (item, e) => {
    if (item.onClick) {
      e.preventDefault();
      setLocalActive(item.id);
      item.onClick();
    }
  };

  const getIconToDisplay = (item, isActive, isHovered) => {
    if (isActive) {
      return item.activeIcon;
    }

    if (isHovered && item.lottieIcon) {
      return <LottieIcon name={item.lottieIcon} size={24} shouldPlay={true} />;
    }

    return item.staticIcon;
  };

  return (
    <div className={`sidebar-container ${className}`} style={{ width }}>
      <div className="sidebar-outline">
        {title && <span className="sidebar-title">{title}</span>}
        <nav className="navs-container">
          {menuItems.length >= 1 ? (
            menuItems.map((item) => {
              const isActive = currentActive === item.id;
              const isHovered = hoveredItem === item.id;
              const iconToDisplay = getIconToDisplay(item, isActive, isHovered);

              if (item.onClick) {
                return (
                  <div
                    key={item.id}
                    className={`navs-item ${isActive ? "active" : ""}`}
                    onClick={(e) => handleItemClick(item, e)}
                    onMouseEnter={() => setHoveredItem(item.id)}
                    onMouseLeave={() => setHoveredItem(null)}
                    style={{ cursor: "pointer" }}
                  >
                    <span >{item.label}</span>
                    <div style={{ display: "flex", gap: "10px" }}>
                      {item.viewIcon && (
                        <div className={`navs-icon ${isActive ? "active" : ""}`}>
                          {React.cloneElement(item.viewIcon, {
                            className: `icon-svg ${isActive ? "active" : ""}`,
                          })}
                        </div>
                      )}
                      {item.editIcon && (
                        <div
                          onClick={(e) => {
                            if (item.onEdit) item.onEdit(e);
                          }}
                          className={`navs-icon ${isActive ? "active" : ""}`}
                        >
                          {React.cloneElement(item.editIcon, {
                            className: `icon-svg ${isActive ? "active" : ""}`,
                          })}
                        </div>
                      )}
                      {item.menuIcon && (
                        <div className={`navs-icon ${isActive ? "active" : ""}`}>
                          {React.cloneElement(item.menuIcon, {
                            className: `${isActive ? "active" : ""}`,
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                );
              }

              return (
                <Link
                  key={item.id}
                  to={item.link}
                  className={`navs-item ${isActive ? "active" : ""}`}
                  onMouseEnter={() => setHoveredItem(item.id)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <span >{item.label}</span>
                  <div className={`navs-icon ${isActive ? "active" : ""}`}>
                    {iconToDisplay || <span className={`icon-svg ${isActive ? "active" : ""}`} />}
                  </div>
                </Link>
              );
            })
          ) : (
            <div className="no-menu">
              
            </div>
          )}
        </nav>
      </div>
    </div>
  );
};